import _ from 'lodash';
import moment from 'moment';
import swal from 'sweetalert';
import formatCurrency from "format-currency";
import createContractModalTemplate from "./modals/createContractModal/createContractModal.html";
import CreateContractModalController from "./modals/createContractModal/createContractModal.controller";
import createPocModal from "./modals/createPocModal/createPocModal.component";
import confirmModal from "../../../common/modals/ConfirmModal/confirmModal.component";

class CustomerDetailsController {
  constructor($rootScope, $http, toastr, $state, AuthenticationService, $stateParams, $uibModal) {
    "ngInject";
    this.name = 'customers';
    this.$uibModal = $uibModal;
    this.loadingCustomer = true;

    this.$http = $http;
    this.$rootScope = $rootScope;
    this.auth = AuthenticationService;
    this.toastr = toastr;
    this.$state = $state;
    this.customer;
    this.showAddContractForm = false;
    this.contractRevenueChartData = [];
    this.newContract = {};
    this.orderBy = {
      field: 'name',
      reverse: false
    };

    this.restUrl = 'admin/customers/'+$stateParams.customerId+'/contracts';

    let self = this;

    this.$http.get($rootScope.apiHost+"/api/admin/customers/"+$stateParams.customerId, {withCredentials: true}).then(function (success) {
      self.customer = success.data;
      // Normalize POC data: ensure 'role' is set from 'type' if needed
      if (self.customer.pointsOfContact && Array.isArray(self.customer.pointsOfContact)) {
        self.customer.pointsOfContact.forEach(function(poc) {
          if (!poc.role && poc.type) {
            poc.role = poc.type;
          }
        });
      }
      self.loadingCustomer = false;
    });

    this.contractFilter = {
      name: '',
      status: 'active'
    }

    this.contractFilterRefresh = false;

    this.contractFilterCriteria = function () {
      return "status="+self.contractFilter.status+"&name="+self.contractFilter.name;
    }

    this.filterContracts = function() {
      this.contractFilterRefresh = true;
    }

    this.contractColumns = [
      {
        displayName: 'Name',
        value: 'name',
        sortable: true,
        dataType: 'number',
        formatting: function (record) {
          return "<a className=\"text-info\" href=\"admin/contracts/"+record.id+"\" >"+record.contractName+"</a>";
        }
      },
      {
        displayName: 'Customer',
        value: 'customer',
        sortable: true,
        sortValue: 'customer',
        dataType: 'text',
        formatting: function (record) {
          return record.customerName;
        }
      },
      {
        displayName: 'Start Date',
        value: 'startDate',
        sortable: true,
        sortValue: 'periodOfPerformance.startDate',
        dataType: 'date',
        formatting: function (record) {
          if (!record.periodsOfPerformance || record.periodsOfPerformance.length === 0) {
            if (record.startDate) {
              return moment(record.startDate).format("MMM, DD, YYYY");
            }
            return '(Not Set)';
          }
          
          // Find the earliest start date
          let earliestStart = moment(record.periodsOfPerformance[0].startDate);
          record.periodsOfPerformance.forEach(pop => {
            const popStart = moment(pop.startDate);
            if (popStart.isBefore(earliestStart)) {
              earliestStart = popStart;
            }
          });
          
          return earliestStart.format("MMM, DD, YYYY");
        }
      },
      {
        displayName: 'End Date',
        value: 'endDate',
        sortable: true,
        sortValue: 'periodOfPerformance.endDate',
        dataType: 'date',
        formatting: function (record) {
          if (!record.periodsOfPerformance || record.periodsOfPerformance.length === 0) {
            if (record.endDate) {
              return moment(record.endDate).format("MMM, DD, YYYY");
            }
            return '(Not Set)';
          }
          
          // Find the latest end date
          let latestEnd = moment(record.periodsOfPerformance[0].endDate);
          record.periodsOfPerformance.forEach(pop => {
            const popEnd = moment(pop.endDate);
            if (popEnd.isAfter(latestEnd)) {
              latestEnd = popEnd;
            }
          });
          
          return latestEnd.format("MMM, DD, YYYY");
        }
      },
      {
        displayName: 'YTD Revenue',
        value: 'yearlyRevenue',
        sortable: true,
        sortValue: 'yearToDateRevenue',
        dataType: 'number',
        formatting: function (record) {
          return '$'+formatCurrency(record.yearlyRevenue);
        }
      },
      {
        displayName: 'All Time Revenue',
        value: 'allTimeRevenue',
        sortable: true,
        sortValue: 'allTimeRevenue',
        dataType: 'date',
        formatting: function (record) {
          return '$'+formatCurrency(record.allTimeRevenue);
        }
      }
    ];



    this.contractRevenueChartOptions = {
        series: {
            pie: {
                show: true
            }
        },
        grid: {
            hoverable: true
        }
    };

    this.opened = {};
    this.open = function($event, elementOpened) {
      $event.preventDefault();
      $event.stopPropagation();
      self.opened[elementOpened] = !self.opened[elementOpened];
    };

    this.datePickerOptions = {
        formatYear: 'yy',
        startingDay: 1
    };

    this.datePickerFormat = 'MMM dd, yyyy';
  }


  checkXEditPermission(permission) {
    let result = false;

    if(this.auth.hasPermission(permission)){
      result = true;
    }

    return result;
  }

  checkPermission(e, permission) {
    if(!this.auth.hasPermission(permission)){
      e.preventDefault();
    }
  }


  changeSortOrder(sortField, defaultSort) {
    this.orderBy = {
      field: sortField,
      reverse: this.orderBy.field === sortField ? !this.orderBy.reverse : defaultSort
    }
  }

  updateCustomerDetails(parameter, value) {
    let self = this;
    let obj = {};
    obj[parameter] = value;
    this.$http.patch(this.$rootScope.apiHost+"/api/admin/customers/"+this.customer.id, obj, {withCredentials: true}).then(function (success) {
      self.customer = success.data;
      self.toastr.success("Successfully updated customer details!", "SUCCESS");
    }, function (failure) {
      self.toastr.error("Could not update customer details.", "ERROR");
    });
  }

  formatDate(date, format) {
    return moment(date).format(format);
  }


  createContractModal() {
    let self = this;
    var modalInstance = this.$uibModal.open({
      template: createContractModalTemplate,
      controller: ['$scope', '$uibModalInstance', '$rootScope', '$http', 'customerId', CreateContractModalController],
      controllerAs: '$ctrl',
      size: 'lg',
      windowClass: "hmodal-info animated zoomIn",
      resolve: {
        customerId: function() {
          return self.customer ? self.customer.id : null;
        }
      }
    });

    modalInstance.result.then(function (contractData) {
      self.$http.post(self.$rootScope.apiHost+'/api/admin/contracts', contractData, { withCredentials: true}).then(function (success) {
        self.toastr.success("Successfully Created Contract", "SUCCESS");
        self.$state.go("admin.contract-details", {'contractId': success.data.id});
      }, function(error) {
        self.toastr.error(error.data && error.data.message ? error.data.message : "Failed to create contract", "ERROR");
      });
    });
  }


  createPocModal() {
    let self = this;
    var modalInstance = this.$uibModal.open(createPocModal);

    modalInstance.success = function (poc) {

      self.$http.post(self.$rootScope.apiHost+'/api/admin/customers/'+self.customer.id+"/pocs", poc, { withCredentials: true}).then(function (success) {
        modalInstance.dismiss();
        self.toastr.success("Successfully Added Point of Contact", "SUCCESS");
        // Ensure role is set from type if backend returns type
        if (success.data && !success.data.role && success.data.type) {
          success.data.role = success.data.type;
        }
        self.customer.pointsOfContact.push(success.data);
      });
    };

    modalInstance.cancel = function () {
      modalInstance.dismiss();
    };
  }


  deletePoc(poc) {
    let self = this;

    // Show confirmation dialog
    const modalInstance = this.$uibModal.open(confirmModal);
    modalInstance.title = "Delete Point of Contact";
    modalInstance.subject = poc.name || "Point of Contact";
    modalInstance.message = "Are you sure you want to delete this point of contact?";

    modalInstance.yes = function() {
      // Normalize poc data - ensure we have the right fields
      const pocToDelete = {
        id: poc.id,
        type: poc.type || poc.role,
        role: poc.role || poc.type,
        name: poc.name,
        email: poc.email,
        phone: poc.phone,
        notes: poc.notes
      };

      self.$http.post(self.$rootScope.apiHost+'/api/admin/customers/'+self.customer.id+"/pocs/delete", pocToDelete, {withCredentials: true}).then(function (success) {
        modalInstance.dismiss();
        self.toastr.success("Successfully Removed Point of Contact", "SUCCESS");
        // Normalize the returned data
        if (success.data && Array.isArray(success.data)) {
          success.data.forEach(function(poc) {
            if (!poc.role && poc.type) {
              poc.role = poc.type;
            }
          });
        }
        self.customer.pointsOfContact = success.data;
      }, function(error) {
        modalInstance.dismiss();
        self.toastr.error(error.data && error.data.message ? error.data.message : "Failed to delete Point of Contact", "ERROR");
      });
    };

    modalInstance.no = function() {
      modalInstance.dismiss();
    };
  }

  validateDataChange(parameter, value) {
    return !angular.equals(this.customer[parameter], value)
  }

}


export default CustomerDetailsController;



// WEBPACK FOOTER //
// ./client/pages/admin/customer-details/customer-details.controller.js